var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tabs", {
    attrs: { list: _vm.list, active: _vm.active },
    on: { click: _vm.tabClick },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }